"use client";
import { useEffect, useState } from "react";
import AssociationApp from "./AssociationApp";
import PartnerPortal from "./PartnerPortal";
import MemberPortal from "./MemberPortal";
import { AuthContext, AuthUser } from "./auth-context";
import { apiJson } from "./api";

const access: Record<string, string[]> = {
  Administrador: [
    "dashboard",
    "members",
    "payments",
    "late",
    "partners",
    "uses",
    "reports",
    "contacts",
    "users",
  ],
  Financeiro: ["dashboard", "payments", "late", "reports", "contacts"],
  Secretaria: ["dashboard", "members", "partners", "uses", "contacts"],
  Parceiro: ["partner-portal"],
  Membro: ["member-portal"],
};

export default function Page() {
  const [user, setUser] = useState<AuthUser | null>(null);
  async function me() {
    try {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 8000);
      const r = await fetch("/api/auth.php", { signal: controller.signal });
      clearTimeout(timer);
      if (r.ok) setUser((await apiJson(r)).user);
    } catch {}
  }
  useEffect(() => {
    me();
  }, []);
  async function logout() {
    await fetch("/api/auth.php", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ action: "logout" }),
    });
    setUser(null);
  }
  if (!user) return <Login success={(u) => setUser(u)} />;
  const context = {
    user,
    logout,
    can: (view: string) => access[user.role]?.includes(view) || false,
  };
  return (
    <AuthContext.Provider value={context}>
      {user.role === "Parceiro" ? (
        <PartnerPortal />
      ) : user.role === "Membro" ? (
        <MemberPortal />
      ) : (
        <AssociationApp />
      )}
    </AuthContext.Provider>
  );
}

function Login({ success }: { success: (u: AuthUser) => void }) {
  const [username, setUsername] = useState(""),
    [password, setPassword] = useState(""),
    [show, setShow] = useState(false),
    [error, setError] = useState(""),
    [busy, setBusy] = useState(false);
  async function login(loginUsername: string, loginPassword: string) {
    setBusy(true);
    setError("");
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 12000);
    try {
      const r = await fetch("/api/auth.php", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          action: "login",
          username: loginUsername,
          password: loginPassword,
        }),
        signal: controller.signal,
      });
      const j = await apiJson(r);
      if (r.ok) success(j.user);
      else setError(j.error || "Não foi possível entrar");
    } catch {
      setError(
        "O servidor demorou para responder. Verifique a conexão e tente novamente.",
      );
    } finally {
      clearTimeout(timer);
      setBusy(false);
    }
  }
  async function submit(e: React.FormEvent) {
    e.preventDefault();
    await login(username, password);
  }
  async function demoMember() {
    setUsername("joao");
    setPassword("Membro@2026");
    await login("joao", "Membro@2026");
  }
  return (
    <div className="login-page">
      <section className="login-brand">
        <div>
          <span className="login-logo">●●●</span>
          <h1>
            ASSOCIA<span>PRO</span>
          </h1>
          <p>Gestão inteligente para associações.</p>
        </div>
        <div className="login-features">
          <p>✓ Membros e carteirinhas</p>
          <p>✓ Financeiro e inadimplência</p>
          <p>✓ Parceiros e benefícios</p>
          <p>✓ Segurança por nível de acesso</p>
        </div>
      </section>
      <section className="login-side">
        <form className="login-card" onSubmit={submit}>
          <div className="login-mini">AP</div>
          <h2>Bem-vindo</h2>
          <p>Entre com seu usuário e senha para acessar o painel.</p>
          {error && <div className="login-error">! {error}</div>}
          <label>
            <span>Usuário</span>
            <input
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Digite seu usuário"
              autoComplete="username"
              required
            />
          </label>
          <label>
            <span>Senha</span>
            <div className="password-input">
              <input
                type={show ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Digite sua senha"
                autoComplete="current-password"
                required
              />
              <button type="button" onClick={() => setShow(!show)}>
                {show ? "Ocultar" : "Mostrar"}
              </button>
            </div>
          </label>
          <button className="login-submit" disabled={busy}>
            {busy ? "Entrando..." : "Entrar no sistema"}
          </button>
          <button
            className="member-demo-login"
            type="button"
            onClick={demoMember}
            disabled={busy}
          >
            {busy
              ? "Abrindo demonstração..."
              : "Ver demonstração do Portal do Membro"}
          </button>
          <small>
            Administrador: <b>admin</b> • <b>Admin@2026</b>
            <br />
            Membro: <b>joao</b> • <b>Membro@2026</b>
          </small>
        </form>
      </section>
    </div>
  );
}
